

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Project } from '@brg/api';

interface IWideCover {
    project?: Project<'Local'>;
}

const initialState = {
    project: undefined,
} as IWideCover;

const WideCoverSlice = createSlice({
    name: 'wideCover',
    initialState,
    reducers: {
        setWideProject(state, action: PayloadAction<Project | undefined>) {
            state.project = action.payload;
        },
    },
});

export const { setWideProject } = WideCoverSlice.actions;
export const WideCoverSelector = (store: { wideCover: IWideCover }): IWideCover => store.wideCover;
export default WideCoverSlice;


import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Project } from '@brg/api';

interface IWideCover {
    project?: Project<'Local'>;
}

const initialState = {
    project: undefined,
} as IWideCover;

const WideCoverSlice = createSlice({
    name: 'wideCover',
    initialState,
    reducers: {
        setWideProject(state, action: PayloadAction<Project | undefined>) {
            state.project = action.payload;
        },
    },
});

export const { setWideProject } = WideCoverSlice.actions;
export const WideCoverSelector = (store: { wideCover: IWideCover }): IWideCover => store.wideCover;
export default WideCoverSlice;
